export default __webpack_public_path__ + "static/cheetah-quote-banner-c067f0e7e2826d629cf8a19e8cd1e0d5.png";